import { useQeScoreSummary } from './useQeScoreSummary';
import { useQeScoreAnalysis } from './useQeScoreAnalysis';
import { useQeScoreStream } from './useQeScoreStream';

export const useQeScore = (apmNumber: string) => {
  const requestId = new Date().toISOString().split('T')[0];

  const analysis = useQeScoreAnalysis(apmNumber, requestId);

  const summary = useQeScoreSummary(
    apmNumber,
    requestId,
    analysis.setQeScoreAnalysisDataFromApi,
  );
  const stream = useQeScoreStream(
    apmNumber,
    requestId,
    analysis.initializeAnalysisResultsForStream,
    analysis.appendEvent,
  );

  return {
    qeScoreSummary: summary.qeScoreSummary,
    qeScoreAnalysisResults: analysis.qeScoreAnalysisResults,
    isQeScoreSummaryLoading: summary.isQeScoreSummaryLoading,
    isRefreshingAnalysisStatus: summary.isRefreshingAnalysisStatus,
    isStreamingLoading: stream.isStreamingLoading,
    isTriggering: stream.isTriggering,
    isAnalysisLoading: analysis.isAnalysisLoading,
    isDownloadingReport: analysis.isDownloadingReport,
    error: summary.error,
    errorType: summary.errorType,
    fetchQeScoreAnalysisResults: analysis.fetchQeScoreAnalysisResults,
    fetchQeScoreAnalysisReport: analysis.fetchQeScoreAnalysisReport,
    fetchQeScoreAnalysisStatus: summary.fetchQeScoreAnalysisStatus,
    streamQeScoreWorkLogs: stream.streamQeScoreWorkLogs,
  };
};
